import React, { useEffect, useState } from "react";
import { DropBox, Tag } from "../../../components";
import { getLanguage } from "../../../utils/environment";
import { useDispatch } from "react-redux";
import { setCategoryList } from "../../Category/redux/actions";
import { getAllWidgets } from "../../Tags/service/tags.service";
import { setWidgetList } from "../../Widget/redux/actions";

const lan = getLanguage();

const Index = ({ data, onChangeWidget }) => {
  const [language, setLanguage] = useState("");
  const [selectWidget, setSelectWidget] = useState("");
  const [widgetList, setWidgetListState] = useState([]);
  const [formData, setFormData] = useState({
    widget: {
      key: "widget",
      label: "Widget",
      size: "lg",
      placeholder: "Select Widgets",
      mainLayerStyles: " flex-column align-content-center mb-3",
      iconName: "",
      isRequired: false,
      loading: false,
      elementConfig: {
        options: [],
      },
      touched: false,
      validation: {
        required: true,
      },
      isValid: false,
      invalidReason: "",
      value: "",
    },
  });

  const dispatch = useDispatch();

  const fetchWidgets = async () => {
    const updateForm = { ...formData };
    updateForm.widget.loading = true;
    updateForm["widget"].elementConfig.options = [];
    const response = await getAllWidgets();
    console.log("get widget", response);

    if (response?.data) {
      let widgetList = await syncWidget(response.data);
      updateForm["widget"].elementConfig.options = widgetList;
      updateForm.widget.loading = false;
      dispatch(setWidgetList(response.data));
      setFormData(updateForm);
    }
  };

  const syncWidget = async (res) => {
    return res.map((widget) => ({
      id: widget.widget_id,
      key: widget.widget_name,
      value: widget.widget_id,
      displayValue: widget.widget_name,
    }));
  };

  // const syncWidget = async (res) => {
  //   let widgetList = [];
  //   for (let widget of res) {
  //     widgetList.push({
  //       id: widget.widget_id,
  //       key: widget.widget_id,
  //       value: widget.widget_name,
  //       displayValue: widget.widget_name,
  //     });
  //   }
  //   return widgetList;
  // };

  useEffect(() => {
    if (formData.widget.elementConfig.options.length === 0) {
      fetchWidgets();
    }
  }, []);

  useEffect(() => {
    if (formData.widget.value) {
      const existing = formData.widget.elementConfig.options?.find(
        (w) => w.id === formData.widget.value
      );
      if (existing) {
        setSelectWidget(existing?.displayValue);
      }
    }
  }, [formData.widget.value]);

  useEffect(() => {
    if (formData.widget.value) {
      const existing = formData.widget.elementConfig.options?.find(
        (w) => w.id === formData.widget.value
      );
      if (existing) {
        setSelectWidget(existing);
      }
    }
  }, [formData.widget.value]);

  // --- When editing, set initial selected widget ---
  useEffect(() => {
    if (data?.widget_id && formData.widget.elementConfig.options.length > 0) {
      const selected = formData.widget.elementConfig.options.find(
        (w) => w.id === data.widget_id
      );
      if (selected) {
        setSelectWidget(selected);
        const updateForm = { ...formData };
        updateForm.widget.value = selected.value;
        setFormData(updateForm);
        onChangeWidget(selected.id);
      }
    }
  }, [data.widget_id]);

  // --- Handle Select Change ---
  const handleWidgetChange = (value) => {
    const selected = widgetList.find((item) => item.value === value);
    const updateForm = { ...formData };
    updateForm.widget.value = value;
    setFormData(updateForm);
    setSelectWidget(selected || null);
    console.log("Widget Select Box:", selected);
    onChangeWidget(selected?.id || "");
  };

  const updateNewsForm = { ...formData };

  return (
    <>
      {/* <DropBox
        data={updateNewsForm.widget}
        onChange={(e) => {
          const updateForm = { ...formData };
          updateForm["widget"].value = e;
          setFormData(updateForm);
          console.log("Widget Select Box:", e);
          onChangeWidget(e);
        }}
      /> */}

      <DropBox
        data={updateNewsForm.widget}
        onChange={(e) => {
          const selected = formData.widget.elementConfig.options.find(
            (item) => item.value === e
          );
          const updateForm = { ...formData };
          updateForm["widget"].value = e;
          setFormData(updateForm);
          setSelectWidget(selected);
          console.log("Widget Select Box:", selected);
          onChangeWidget(selected?.id);
        }}
      />

      {/* <div className="d-flex flex-row flex-wrap">
        {selectWidget && (
          <Tag
            key={selectWidget.id}
            data={{
              tagName: selectWidget?.displayValue,
              tagIcon: "",
              type: "primary",
              isIcon: true,
            }}
            onClick={() => {
              setSelectWidget();
            }}
          />
        )}
      </div> */}

      <div className="d-flex flex-row flex-wrap mt-2" style={{ gap: "8px" }}>
        {selectWidget && (
          <Tag
            key={selectWidget.id}
            data={{
              tagName: selectWidget?.displayValue,
              tagIcon: "",
              type: "primary",
              isIcon: true,
            }}
            onClick={() => {
              setSelectWidget("");
              const resetForm = { ...formData };
              resetForm.widget.value = "";
              setFormData(resetForm);
              onChangeWidget("");
            }}
          />
        )}
      </div>
    </>
  );
};

export default Index;
